"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _classnames = _interopRequireDefault(require("classnames"));

var S = _interopRequireWildcard(require("../../Checkbox/styled"));

var _peractoUi = require("@peracto/peracto-ui");

var _excluded = ["name", "label", "help", "className", "options"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var CheckboxGroup = function CheckboxGroup(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$help = _ref.help,
      help = _ref$help === void 0 ? false : _ref$help,
      className = _ref.className,
      options = _ref.options,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name
  }, function (_ref2) {
    var field = _ref2.field,
        form = _ref2.form;
    var error = (0, _formik.getIn)(form.errors, name);

    if (error) {
      var errorFieldName = label ? label : 'This';
      error = error.replace(field.name, errorFieldName);
    }

    props.className = (0, _classnames["default"])('form-control', className);

    if (help) {
      props['aria-describedby'] = "".concat(name, "Help");
    }

    if (!field.value) {
      field.value = [];
    }

    return /*#__PURE__*/_react["default"].createElement(_formik.FieldArray, {
      name: field.name
    }, function (_ref3) {
      var push = _ref3.push,
          remove = _ref3.remove;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('form-group', {
          'has-error': error
        })
      }, label.length > 0 && /*#__PURE__*/_react["default"].createElement("label", {
        className: "mb-0"
      }, label), options.map(function (option, idx) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: "".concat(field.name, "-").concat(idx)
        }, /*#__PURE__*/_react["default"].createElement(S.Checkbox, {
          htmlFor: option.value
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: option.value,
          type: "checkbox",
          value: field.value.includes(option.value),
          onChange: function onChange(e) {
            var target = e.currentTarget;

            if (target.checked) {
              push(target.id);
            } else {
              remove(idx, 1);
            }
          },
          className: className,
          "data-value": field.value,
          disabled: form.isSubmitting || props.disabled
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "checkbox"
        }), option.label.length > 0 && option.label), option.help && /*#__PURE__*/_react["default"].createElement(_peractoUi.Help, {
          id: "".concat(option.value, "Help"),
          help: option.help
        }));
      }), help && /*#__PURE__*/_react["default"].createElement(_peractoUi.Help, {
        id: "".concat(name, "Help"),
        help: help
      }), error && /*#__PURE__*/_react["default"].createElement(Error, {
        error: error
      }));
    });
  });
};

CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.propTypes = {
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  options: _propTypes["default"].array.isRequired,
  placeholder: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var _default = CheckboxGroup;
exports["default"] = _default;